// Regular expression that all names in the model must adhere to.
// - The name may not start with underscore, we reserve it for internal names.
// - The name may not contain '.', to allow us to construct paths.
export const NAME_PATTERN = '^[A-Za-z0-9][A-Za-z0-9_]*$';

// Reserved name to indicate functional unit node in an eval graph.
// Guaranteed to have no conflict since we reserve '__' prefix for internal use.
export const FUNCTIONAL_UNIT_NODE_NAME = '__functional_unit__';

export const REQUIRED_ERROR_PHRASE = 'cannot be empty';

export const MAX_LENGTH_OF_NAMES = 130;

export const NAME_TOO_LONG_ERROR = ` is too long of a name: names can be no longer than ${MAX_LENGTH_OF_NAMES} characters.`;

export const LSCRIPT_NAME_PREFIX_EMISSIONS_FACTOR = 'emissions_factor';
export const LSCRIPT_NAME_PREFIX_EMISSIONS_ACTIVITY = 'activity';

/**
 * Slack ID for @calculation-oncall
 */
export const CALC_ONCALL_MENTION = `<!subteam^S04MTMG9R6V>`;

/***
 * Slack ID for @methodology-oncall
 */
export const METHODOLOGY_ONCALL_MENTION = `<!subteam^S0644037SAZ>`;

/***
 * Slack ID for @cmv-traffic-controller
 */
export const CMV_TRAFFIC_CONTROLLER_MENTION = `<!subteam^S07C7TLELJ0>`;

/**
 * LEGACY! DO NOT USE UNLESS YOU KNOW THE TERRIBLE REPERCUSSIONS!
 *
 * Special local variable names that ReliableInputQuantityService looks for.
 *
 * These are not codegenned, just very unique so as not to conflict with other
 * variable names.
 */
const RIQS_LOCAL_VARIABLE_KEY_PRODUCT = 'wcg_product_quantity_6d4800da';
const RIQS_LOCAL_VARIABLE_KEY_MATERIAL = 'wcg_material_quantity_e45e216c';
const RIQS_LOCAL_VARIABLE_KEY_ELECTRICITY = 'wcg_electricity_quantity_k24e759j';
export const RIQS_LOCAL_VARIABLES = [
  RIQS_LOCAL_VARIABLE_KEY_PRODUCT,
  RIQS_LOCAL_VARIABLE_KEY_MATERIAL,
  RIQS_LOCAL_VARIABLE_KEY_ELECTRICITY,
];

/**
 * LEGACY! DO NOT USE UNLESS YOU KNOW THE TERRIBLE REPERCUSSIONS!
 *
 * Special region attribute names that ReliableInputQuantityService looks for.
 */
export const RIQS_REGION_ATTRIBUTES = [
  'org_material',
  'org_raw_material',
  'ws_raw_material',
  'product',
] as const;

// Pipeline run descriptions
export const CRON_TRIGGERED_DESCRIPTION = `Smoke test `;

// Date of emissions models GA
export const EMISSIONS_MODEL_GA_DATE = new Date('2023-07-01');
